import React, { Component } from "react";
import PropTypes from "prop-types";
import Section from "components/layout/Section";
import Argumentation from "components/blocks/Argumentation";
import i18n from "i18n";
import css from "./Argumentations.module.scss";

class Argumentations extends Component {
  render() {
    const { argumentations, showTitle } = this.props;

    if (!argumentations) {
      return null;
    }
    const filteredArgumentations = argumentations.filter(
      (argumentation) => !argumentation.isHidden,
    );

    if (filteredArgumentations.length < 1) {
      return null;
    }

    return (
      <Section className={css.argumentations}>
        {filteredArgumentations.map((argumentation, index) => {
          if (showTitle === true && index === 0) {
            return (
              <div key={argumentation.uuid} className={css.noBreakInside}>
                <div className={css.sectionTitle}>{i18n.t("global.argumentations")}</div>
                <Argumentation
                  index={index + 1}
                  key={argumentation.uuid}
                  {...argumentation}
                />
              </div>
            );
          }
          return (
            <Argumentation
              index={index + 1}
              key={argumentation.uuid}
              {...argumentation}
            />
          );
        })}
      </Section>
    );
  }
}

Argumentations.propTypes = {
  argumentations: PropTypes.array,
  showTitle: PropTypes.bool,
};

export default Argumentations;
